import omit from 'lodash-es/omit';
import { ISalesCall, SalesCallActionKeys as keys, SalesCallActionTypes } from '.';
import { uniqPrimativeMerge } from '../../utils/arrayUtils';

interface ISalesCallHash {
  hash: { [index: number]: ISalesCall };
  paged: { ids: number[]; totalItems: number };
  loadedDates: Array<Date | string>;
  loadingPaged: boolean;
  loadingDates: Array<Date | string>;
  salesCallsByDate: { [index: string]: number[] };
}

export interface ISalesCallState extends ISalesCallHash {}

const initialState: ISalesCallState = {
  hash: {},
  loadedDates: [],
  loadingDates: [],
  loadingPaged: false,
  paged: { ids: [], totalItems: 0 },
  salesCallsByDate: {}
};

export function salesCallReducer(state: ISalesCallState = initialState, action: SalesCallActionTypes): ISalesCallState {
  switch (action.type) {
    case keys.FETCH_SALESCALLS_BY_DATE:
      return {
        ...state,
        loadingDates: Array.from(new Set([...state.loadingDates, action.payload.date]))
      };
    case keys.FETCH_SALESCALLS_BY_DATE_FULFILLED:
      return {
        ...state,
        loadedDates: Array.from(new Set([...state.loadedDates, action.payload.date])),
        loadingDates: state.loadingDates.filter(x => x !== action.payload.date),
        salesCallsByDate: {
          ...state.salesCallsByDate,
          [action.payload.date.toString()]: action.payload.salesCalls.map(x => x.salesCallId)
        }
      };
    case keys.FETCH_SALESCALLS_BY_DATE_REJECTED:
      return {
        ...state,
        loadedDates: Array.from(new Set([...state.loadedDates, action.payload.date])),
        loadingDates: state.loadingDates.filter(x => x !== action.payload.date)
      };
    case keys.PROCESS_SALESCALLS:
      return {
        ...state,
        hash: action.payload.reduce((newHash, sc) => {
          return {
            ...newHash,
            [sc.salesCallId]: sc
          };
        }, state.hash)
      };
    case keys.DELETE_SALESCALL_FULFILLED:
      return {
        ...state,
        hash: omit(state.hash, action.payload),
        paged: {
          ...state.paged,
          ids: state.paged.ids.filter(x => x !== action.payload)
        }
      };
    case keys.RESET_SALESCALL_IDS:
      return {
        ...state,
        paged: {
          ...state.paged,
          ids: []
        }
      };
    case keys.SET_PAGED_SALES_CALLS:
      return {
        ...state,
        paged: {
          ids: uniqPrimativeMerge(state.paged.ids, action.payload.items.map(x => x.salesCallId)),
          totalItems: action.payload.totalItems
        }
      };
    case keys.TOGGLE_LOADING_PAGED:
      return {
        ...state,
        loadingPaged: !state.loadingPaged
      };
    default:
      return state;
  }
}
